import { Link } from 'react-router-dom';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageFooter from './components/pageFooter';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import './NailCommissionPage.css';

const RetroWindow = ({ title, to, gif, name, desc, price, time }) => (
    <Link to={to} className="retro-window">
        <div className="retro-titlebar">
            <span className="retro-close">✕</span>
            <span className="retro-titlebar-text">{title}</span>
            <div style={{ width: '10px' }} />
        </div>
        <div className="retro-screen">
            <img src={gif} alt="" className="retro-gif" />
            <span className="retro-name">{name}</span>
            <span className="retro-desc">{desc}</span>
            <span className="retro-price">{price}</span>
            <span className="retro-time">{time}</span>
            <span className="retro-cta">open →</span>
        </div>
    </Link>
);

export const CommissionsPage = () => {
    return (
        <PageLayout>
            <PageContainer>
                <PageBody>
                    <NavigationHeader />
                    <PageText>
                        <div className="commissions-landing">
                            <h2 className="commissions-heading">⟡₊ ⊹ commissions ⟡₊ ⊹</h2>
                            <p className="commissions-subtext">handmade with love by egg tarty art studio</p>

                            <div className="commissions-cards">
                                <RetroWindow
                                    title="nails.exe"
                                    to="/shop/custom-commission"
                                    gif={require("../images/site/tamagotchi-mametchi.gif")}
                                    name="NAILS"
                                    desc="custom press-on nail sets made to order. choose your shape, length, and design."
                                    price=""
                                    time="✧ 2 week turnaround"
                                />
                                <RetroWindow
                                    title="art.exe"
                                    to="/shop/art-commission"
                                    gif={require("../images/site/kuchipatchi-spinning.gif")}
                                    name="ART"
                                    desc="digital illustrations and sticker designs personalized for you."
                                    price=""
                                    time="✧ 1–3 week turnaround"
                                />
                            </div>

                            <div className="commissions-footer-note">
                                <p>questions? DM <a href="https://instagram.com/egg.tarty" target="_blank" rel="noopener noreferrer">@egg.tarty</a> on instagram</p>
                                <p>rush orders (under 2 weeks) have a +$20 fee</p>
                            </div>
                        </div>
                    </PageText>
                    <PageFooter />
                </PageBody>
            </PageContainer>
        </PageLayout>
    );
};
